import { Controller } from "@hotwired/stimulus"
import { calculateResults, formatCurrency } from "../modules/money_smart/fee_calculator_helpers"
import { createLineChart, destroyChart } from "../modules/money_smart/chart_helpers"

export default class extends Controller {
  static targets = [
    "balanceInput", "salaryInput", "contributionSelect",
    "yearsSlider", "yearsDisplay", "chartCanvas", "resultsBody"
  ]

  static values = {
    funds: Array,
    defaultBalance: Number,
    defaultSalary: Number,
    defaultContribution: Number,
    projectionYears: Number
  }

  chart = null

  connect() {
    this.calculate()
  }

  disconnect() {
    destroyChart(this.chart)
    this.chart = null
  }

  calculate() {
    const params = this.getParams()
    if (this.hasYearsDisplayTarget) {
      this.yearsDisplayTarget.textContent = params.years
    }

    const results = calculateResults(this.fundsValue, params)
    this.renderResults(results)
    this.renderChart(results, params.years)
  }

  getParams() {
    return {
      balance: parseFloat(this.balanceInputTarget.value) || 0,
      salary: parseFloat(this.salaryInputTarget.value) || 0,
      contributionRate: parseInt(this.contributionSelectTarget.value, 10) || 3,
      years: parseInt(this.yearsSliderTarget.value, 10) || 30
    }
  }

  renderResults(results) {
    const sorted = [...results].sort((a, b) => b.finalBalance - a.finalBalance)
    this.resultsBodyTarget.innerHTML = sorted.map(r =>
      `<tr>
        <td class="font-medium">${this.escapeHtml(r.name)}</td>
        <td class="text-right money-value">${r.fees.toFixed(2)}%</td>
        <td class="text-right money-value">${formatCurrency(r.totalFeesPaid)}</td>
        <td class="text-right money-value font-semibold">${formatCurrency(r.finalBalance)}</td>
      </tr>`
    ).join("")
  }

  async renderChart(results, years) {
    destroyChart(this.chart)
    this.chart = null

    const labels = Array.from({ length: years + 1 }, (_, i) => `Year ${i}`)
    const palette = ["#6D28D9", "#10B981", "#3B82F6", "#F59E0B", "#EC4899"]
    const top = [...results].sort((a, b) => b.finalBalance - a.finalBalance).slice(0, 5)

    const datasets = top.map((r, i) => ({
      label: r.name,
      data: r.balances,
      borderColor: palette[i % palette.length],
      backgroundColor: "transparent",
      tension: 0.3,
      pointRadius: 0,
      pointHoverRadius: 4
    }))

    this.chart = await createLineChart(this.chartCanvasTarget, labels, datasets)
  }

  escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
